<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-8">
            <div class="d-flex align-items-center">
                <div class="form-content w-100 white-content">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="name">Nombre</label>
                                <input type="text" :value="userData.name" disabled/>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="surnames">Apellidos</label>
                                <input type="text" :value="userData.surnames" disabled/>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="text" :value="userData.email" disabled/>
                            </div>
                        </div>
                    </div>                            
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'userData' ]
    }
</script>